import { Box, styled } from '@mui/material'
import { mobile } from '../../../utils/breakpoints'
import { ImageSkeleton } from '../../Skeleton/ImageSkeleton'

export const LogoContainer = styled(Box)`
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 120px;
  background-color: ${({ theme }) => theme.palette.background.light};
  border-radius: 25px;
  padding: 15px 45px;
  transform: translateY(50%);
  box-sizing: border-box;

  ${({ theme }) =>
    mobile(theme, {
      height: '100px',
      padding: '10px 28px',
      transform: 'translateY(30%)',
    })}
`

export const LogoImage = styled('img')`
  height: 100%;
  width: auto;
  max-width: min(220px, 70vw);
  object-fit: contain;
`

export const LogoSkeleton = styled(ImageSkeleton)`
  height: 120px;
  width: min(210px, 90vw);
  border-radius: 25px;
  transform: translateY(50px);

  ${({ theme }) =>
    mobile(theme, {
      height: '100px',
      width: 'min(236px, 90vw)',
      transform: 'translateY(30px)',
    })}
`
